function ffgc() {
    var fw = document.getElementById('fw').value;
    var bw = document.getElementById('bw').value;
    var gh = document.getElementById('gh').value;
    var fd = document.getElementById('fd').value;
    if (fw == '' || bw == '' || gh == '' || fd == '') {
        alert("Please fill out all of the parameters!");
        if (fw == '') {
            setfocus('fw');
        } else if (bw == '') {
            setfocus('bw');
        } else if (gh == '') {
            setfocus('gh');
        } else if (fd == '') {
            setfocus('fd');
        }
    } else {
        fw = parseFloat(document.getElementById('fw').value);
        bw = parseFloat(document.getElementById('bw').value);
        gh = parseFloat(document.getElementById('gh').value);
        fd = parseFloat(document.getElementById('fd').value);
        if (isNaN(fw) || isNaN(bw) || isNaN(gh) || isNaN(fd)) {
            alert("Enter Only Numeric values.");
            if (isNaN(fw)) {
                setfocus('fw');
            } else if (isNaN(bw)) {
                setfocus('bw');
            } else if (isNaN(gh)) {
                setfocus('gh');
            } else if (isNaN(fd)) {
                setfocus('fd');
            }
        } else {
            var sum = eval(fw + bw) / 2;
            var ans = Math.round(sum * (gh * fd) / (231) * 12, 2);
            document.getElementById('ffgcans').innerHTML = ans;
        }
    }
}

function rfgc() {
    var dm = document.getElementById('dm').value;
    var gd = document.getElementById('gd').value;
    if (dm == '' || gd == '') {
        alert("Please fill out all of the parameters!");
        if (dm == '') {
            setfocus('dm');
        } else if (gd == '') {
            setfocus('gd');
        }
    } else {
        dm = parseFloat(document.getElementById('dm').value);
        gd = parseFloat(document.getElementById('gd').value);
        if (isNaN(dm) || isNaN(gd)) {
            alert("Enter Only Numeric values.");
            if (isNaN(dm)) {
                setfocus('dm');
            } else if (isNaN(gd)) {
                setfocus('gd');
            }
        } else {
            var ans = Math.round(eval(dm * dm * gd / 231 * 12 * 0.8), 2);
          console.log(ans);
            document.getElementById('rfgcans').innerHTML = ans;
        }
    }
}

function sfgc() {
    var pl = document.getElementById('pl').value;
    var pw = document.getElementById('pw').value;
    var gdi = document.getElementById('gdi').value;
    if (pl == '' || pw == '' || gdi == '') {
        alert("Please fill out all of the parameters!");
        if (pl == '') {
            setfocus('pl');
        } else if (gd == '') {
            setfocus('gd');
        } else if (gdi == '') {
            setfocus('gdi');
        }
    } else {
        pl = parseFloat(document.getElementById('pl').value);
        pw = parseFloat(document.getElementById('pw').value);
        gdi = parseFloat(document.getElementById('gdi').value);
        if (isNaN(pl) || isNaN(pw) || isNaN(gdi)) {
            alert("Enter Only Numeric values.");
            if (isNaN(pl)) {
                setfocus('pl');
            } else if (isNaN(gd)) {
                setfocus('gd');
            } else if (isNaN(gdi)) {
                setfocus('gdi');
            }
        } else {
            var ans = Math.round(pl * pw * gdi / 231 * 12, 2);
            document.getElementById('sfgcans').innerHTML = ans;
        }
    }
}

function setfocus(el) {
  document.getElementById(el).focus();
}